import { USER_TYPES_LIST, USER_TYPES_LIST_ERROR, USER_TYPES_LIST_SUCCESS, USERS_LIST, USERS_LIST_ERROR, USERS_LIST_SUCCESS, VULNERABLE_DETAILS, VULNERABLE_INSPECTION_LIST, VULNERABLE_INSPECTION_LIST_ERROR, VULNERABLE_INSPECTION_LIST_SUCCESS, VULNERABLE_LIST, VULNERABLE_LIST_ERROR, VULNERABLE_LIST_SUCCESS } from './constants';

export default function vulnerablepatchdata(state, action) {
	let userTypes = [];
	switch (action.type) {
      
	case VULNERABLE_LIST:
		return { ...state, pending: true };
	case VULNERABLE_LIST_SUCCESS:
		return { ...state, vulnerable_patch_data: action.payload, pending: false };
	case VULNERABLE_DETAILS:
		return { ...state, details: action.payload, pending: false };
	case VULNERABLE_LIST_ERROR:
		return { ...state, error: true, pending: false };

	case VULNERABLE_INSPECTION_LIST:
		return { ...state, pending: true };
	case VULNERABLE_INSPECTION_LIST_SUCCESS:
		return { ...state, inspection_data: action.payload, pending: false };
	case VULNERABLE_INSPECTION_LIST_ERROR:
		return { ...state, error: true, pending: false };

	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };
	case USER_TYPES_LIST:
		return { ...state, loading: true };
	case USER_TYPES_LIST_SUCCESS:
		
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
				let data = {};
		
				data.id = item.id ? item.id : 0;
				data.userType = item.userType ? item.userType : '<Not Set>';
				data.createdAt = item.createdAt ? item.createdAt : '';
				data.updatedAt = item.updatedAt ? item.updatedAt : '';
				data.aliasName = item.aliasName ? item.aliasName : '';
		
				return userTypes.push(data);
			});
		
			return { ...state, userTypes: userTypes, loading: false, error: false };
		} else {
			if (action.payload && action.payload.data && action.payload.data.length === 0) {
				return { ...state, userTypes: userTypes, loading: false, error: false };
			} else {
				return { ...state, loading: false, error: true };
			}
		}
		
	case USER_TYPES_LIST_ERROR:
		return { ...state, loading: false, error: true };

      
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}